// extracted by mini-css-extract-plugin
export default {"card":"TeacherClassCard_card__bPcrA","rows":"TeacherClassCard_rows__kOoSU","head":"TeacherClassCard_head__06lBh","active":"TeacherClassCard_active__FMu-x"};